<template>
  <slot :product-titles>
    <h1
      v-if="
        (productTitles?.subtitle || (isLpoActive && selectedGradeLabel)) &&
        !isMasterPPUrl
      "
      class="mb-8 flex flex-col"
    >
      <span class="heading-1">{{ productTitles.default }}</span>
      <div
        v-if="isLpoActive && subtitleElements.length"
        class="mt-8 flex flex-wrap gap-8"
      >
        <RevTag
          v-for="element in subtitleElements"
          :key="element"
          :label="element"
          variant="secondary"
          variation="outline"
        />
      </div>
      <span v-else-if="productTitles?.subtitle" class="body-2">{{
        productTitles.subtitle
      }}</span>
    </h1>

    <h1 v-else-if="productTitles?.default" class="heading-1 mb-8">
      {{ productTitles?.default }}
    </h1>
  </slot>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevTag } from '@ds/components/Tag'

import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useGoogleShopping } from '~/scopes/product-core/composables/useGoogleShopping/useGoogleShopping'
import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

const { data: productResponse } = useFetchProduct()
const { data: pickersResponse } = useFetchPickers()

const productTitles = computed(() => productResponse.value?.titles)

const selectedGradeLabel = computed(() => {
  const gradeGroup = pickersResponse.value?.pickerGroups.find(
    (g) => g.id === 'grades',
  )

  return gradeGroup?.items.find((item) => item.selected)?.label ?? null
})

const subtitleElements = computed(() => {
  const parts = productTitles.value?.subtitle?.split(' • ') ?? []

  return selectedGradeLabel.value ? [selectedGradeLabel.value, ...parts] : parts
})

const { isMasterPPUrl } = useMasterPP()
const { isLpoActive } = useGoogleShopping()
</script>
